<div class="paybee-modal-header d-flex flex-column p-0 mb-3">
    <div class="d-flex align-items-center">
        <img *ngIf="auctionItem?.imageUrl" class="mr-3" [src]="auctionItem.imageUrl" alt="Auction Item Picture" style="border-radius: 4px; max-width: 112px; align-self: center;">
        <img *ngIf="!auctionItem?.imageUrl" class="mr-3" src="/images/org_logo_default_v2.svg" alt="Auction Item Picture" style="border-radius: 4px; max-width: 112px; align-self: center;">

        <span *ngIf="auctionItem" class="subtitle-1">{{auctionItem.name}}</span>
    </div>
</div>
<div *ngIf="auctionItem" class="modal-body p-0">
    <div class="d-flex">
        <mdb-tabs class="mdb-tabs mdb-tabs--auction w-100">
            <mdb-tab title="Bids ({{currentBids.length}})">
                <div class="grey-background">
                    <div *ngIf="currentBids.length !== 0" class="bids-container m-4 px-3">
                        <table *ngIf="currentBids.length !== 0" class="auction-detail-modal-table w-100" >
                            <tr class="p-2 caption">
                                <th>Bidder</th>
                                <th style="min-width: 60px;">Bid</th>
                                <th style="min-width: 60px;">Added by</th>
                                <th></th>
                            </tr>
                        <ng-container *ngIf="currentBids">
                            <tr *ngFor="let bid of currentBids" class="caption">
                                <td>
                                    <div class="mb-1 d-flex align-items-center">
                                        <span (click)="seeBidderDetails(bid)" class="auction-bidder-name subtitle-1 cursor--pointer p-0 mr-2">
                                            <i *ngIf="bid.winningBid" class='fas fa-trophy pr-1' style='color: #ffab40;'></i>
                                            {{bid.userInfo.name}}
                                        </span>

                                        @if(usersWithFundingSourceMap && usersWithFundingSourceMap.get(bid.userInfo.id)){
                                            <svg
                                                [attr.title]="usersWithFundingSourceMap.get(bid.userInfo.id).fundingSource.sourceName"
                                                placement="top"
                                                initTooltip
                                                viewBox="0 0 32 21" style="width: 20px;"
                                                >
                                                <g fill="green" fill-rule="evenodd">
                                                    <g class="Icon-fill">
                                                        <g transform="translate(0 2)">
                                                            <path d="M26.58 19H2.42A2.4 2.4 0 0 1 0 16.62V2.38A2.4 2.4 0 0 1 2.42 0h24.16A2.4 2.4 0 0 1 29 2.38v14.25A2.4 2.4 0 0 1 26.58 19zM10 5.83c0-.46-.35-.83-.78-.83H3.78c-.43 0-.78.37-.78.83v3.34c0 .46.35.83.78.83h5.44c.43 0 .78-.37.78-.83V5.83z" opacity=".2"></path>
                                                            <path d="M25 15h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0H4c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1z" opacity=".3"></path>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                        }
                                    </div>

                                    <span class="body-3 grey-text font-weight-400">{{bid.userInfo.email}}</span>
                                </td>
                                <td class="subtitle-2">{{getNumberStr(bid.amount)}}</td>
                                <td class="font-weight-400">
                                    <span *ngIf="!bid.volunteerInfo && !bid.isAutoBid">Self</span>
                                    <span *ngIf="bid.volunteerInfo">{{bid.volunteerInfo.name}}</span>
                                    <span *ngIf="bid.isAutoBid">AutoBid</span> 
                                    <br>
                                    <div class="grey-text caption">
                                        {{ moment(bid.created).format('YYYY/MM/DD') }}
                                        {{ moment(bid.created).format('h:mm:ss a') }}
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex ml-3 show" x-placement="bottom-end">                                
                                        <app-auction-bidder-popover [data] = "bid" [auctionCampaign]="auctionCampaign"></app-auction-bidder-popover>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                        </table>
                    </div>
                    <span class="my-5 d-block text-center" *ngIf="!auctionItem.currentBids || auctionItem.currentBids.length === 0" >No Bids Yet</span>
                </div>
            </mdb-tab>
            <mdb-tab *ngIf="auctionType != 1" title="AutoBids ({{currentAutoBids.length}})">
                <div class="grey-background">
                    <div *ngIf="currentAutoBids.length !== 0" class="bids-container m-4 px-3">
                        <table *ngIf="currentAutoBids.length !== 0" class="auction-detail-modal-table w-100">
                            <tr class="p-2 caption">
                                <th>Bidder</th>
                                <th style="min-width: 60px;">Max Bid</th>
                                <th style="min-width: 60px;">Status</th>
                                <th></th>
                            </tr>
                        <ng-container *ngIf="auctionItem.currentAutoBids">
                            <tr *ngFor="let autoBid of auctionItem.currentAutoBids" class="caption">
                                <td> 
                                    <div class="mb-1 d-flex align-items-center">
                                        <span (click)="seeBidderDetails(autoBid)" class="auction-bidder-name subtitle-1 cursor--pointer p-0 mr-2">{{autoBid.userInfo.name}}</span>
                                        @if(usersWithFundingSourceMap && usersWithFundingSourceMap.get(autoBid.userInfo.id)){
                                            <svg 
                                                [attr.title]="usersWithFundingSourceMap.get(autoBid.userInfo.id).fundingSource.sourceName"
                                                placement="top"
                                                initTooltip
                                                viewBox="0 0 32 21" style="width: 20px;"
                                                >
                                                <g fill="green" fill-rule="evenodd">
                                                    <g class="Icon-fill">
                                                        <g transform="translate(0 2)">
                                                            <path d="M26.58 19H2.42A2.4 2.4 0 0 1 0 16.62V2.38A2.4 2.4 0 0 1 2.42 0h24.16A2.4 2.4 0 0 1 29 2.38v14.25A2.4 2.4 0 0 1 26.58 19zM10 5.83c0-.46-.35-.83-.78-.83H3.78c-.43 0-.78.37-.78.83v3.34c0 .46.35.83.78.83h5.44c.43 0 .78-.37.78-.83V5.83z" opacity=".2"></path>
                                                            <path d="M25 15h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0H4c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1z" opacity=".3"></path>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                        }
                                    </div>
                                    <span class="body-3 grey-text font-weight-400">{{autoBid.userInfo.email}}</span>
                                </td>

                                <td class="subtitle-2">{{getNumberStr(autoBid.amount)}}</td>
                                <td class="font-weight-400">{{autoBid.exhausted ? 'Done' : 'Active'}}</td>
                                <td>
                                    <div class="d-flex ml-3 show" x-placement="bottom-end">                                
                                        <app-auction-bidder-popover [data] = "autoBid" [auctionCampaign]="auctionCampaign"></app-auction-bidder-popover>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                        </table>
                    </div>
                    <span class="my-5 d-block text-center" *ngIf="!auctionItem.currentAutoBids || auctionItem.currentAutoBids.length === 0" >No Auto Bids Yet</span>
                </div>
            </mdb-tab>
            <mdb-tab title="Sold ({{soldCount}})">
                <div class="grey-background">
                    <div *ngIf="soldItems.length !== 0" class="bids-container m-4 px-3">
                        <table *ngIf="soldItems.length !== 0" class="auction-detail-modal-table w-100" >
                            <tr class="p-2 caption">
                                <th>Buyer</th>
                                <th>Amount</th>
                                <th style="min-width: 60px;">Status</th>
                                <th style="min-width: 60px;">Time</th>
                            </tr>
                            <ng-container *ngIf="auctionItem.soldItems">
                                <tr *ngFor="let soldItem of auctionItem.soldItems" class="caption">
                                    <td> 
                                        <div class="mb-1 d-flex align-items-center">
                                            <span (click)="seeBidderDetails(soldItem)" class="auction-bidder-name subtitle-1 cursor--pointer p-0 mr-2">
                                                <i *ngIf="soldItem.isWinningBid" class='fas fa-trophy pr-1' style='color: #aa66cc;'></i>
                                                {{soldItem.userInfo.name}}
                                            </span>

                                            @if(usersWithFundingSourceMap && usersWithFundingSourceMap.get(soldItem.userInfo.id)){
                                                <svg 
                                                    [attr.title]="usersWithFundingSourceMap.get(soldItem.userInfo.id).fundingSource.sourceName"
                                                    placement="top"
                                                    initTooltip
                                                    viewBox="0 0 32 21" style="width: 20px;"
                                                    >
                                                    <g fill="green" fill-rule="evenodd">
                                                        <g class="Icon-fill">
                                                            <g transform="translate(0 2)">
                                                                <path d="M26.58 19H2.42A2.4 2.4 0 0 1 0 16.62V2.38A2.4 2.4 0 0 1 2.42 0h24.16A2.4 2.4 0 0 1 29 2.38v14.25A2.4 2.4 0 0 1 26.58 19zM10 5.83c0-.46-.35-.83-.78-.83H3.78c-.43 0-.78.37-.78.83v3.34c0 .46.35.83.78.83h5.44c.43 0 .78-.37.78-.83V5.83z" opacity=".2"></path>
                                                                <path d="M25 15h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0H4c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1z" opacity=".3"></path>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                            }
                                        </div>
                                        <span class="body-3 grey-text font-weight-400">{{soldItem.userInfo.email}}</span>
                                    </td>
                                    <td class="subtitle-2">{{getNumberStr(soldItem.amount)}}</td>
                                    <td>
                                        <div class="d-flex">
                                            <i *ngIf="soldItem.status == 0" data-toggle="tooltip" data-placement="bottom" title="Paid" class="fas fa-dollar-sign fa-lg mr-3" style="color: #25C157;"></i>
                                            <i *ngIf="soldItem.status != 0" data-toggle="tooltip" data-placement="bottom" title="Pending" class="fas fa-dollar-sign fa-lg mr-3" style="color: #CCCCCC;"></i>

                                            <i *ngIf="soldItem.delivered && soldItem.status == 0" data-toggle="tooltip" data-placement="bottom" title="Mark As Not Delivered"
                                                class="fas fa-shipping-fast fa-lg cursor--pointer" 
                                                style="color: #25C157;"
                                                (click)="updateDeliveryStatus(soldItem.transactionId , soldItem.delivered)">
                                            </i>
                                            <i *ngIf="!soldItem.delivered && soldItem.status == 0"  data-toggle="tooltip" data-placement="bottom" title="Mark As Delivered"
                                                class="fas fa-shipping-fast fa-lg cursor--pointer" 
                                                style="color: #CCCCCC;"
                                                (click)="updateDeliveryStatus(soldItem.transactionId , soldItem.delivered)">
                                            </i>
                                            <i *ngIf="soldItem.status != 0" data-toggle="tooltip" data-placement="bottom" title="Must Be Paid Before Delivery"
                                                class="fas fa-shipping-fast fa-lg cursor--pointer" 
                                                style="color: #CCCCCC;">
                                            </i>
                                        </div>
                                        
                                    </td>
                                    <td class="grey-text font-weight-400">
                                        {{ moment.unix(soldItem.date).format('YYYY/MM/DD') }}
                                        {{ moment.unix(soldItem.date).format('h:mm:ss a') }}
                                    </td>
                                </tr>
                            </ng-container>
                        </table>
                    </div>
                    <span class="my-5 d-block text-center" *ngIf="!auctionItem.soldItems || auctionItem.soldItems.length == 0" >No Sold Items Yet</span>
                </div>
            </mdb-tab>
        </mdb-tabs>
    </div>
</div>